<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Torneos"   />

    <Tournaments />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import Tournaments from "@/components/Pages/Admin/Tournaments/index.vue";

export default defineComponent({
  name: "TournamentsPage",
  components: {
    PageTitle,
    Tournaments,
  },
});
</script>
